import { render, staticRenderFns } from "./VVideoCon.vue?vue&type=template&id=2da4aa94&scoped=true&"
import script from "./VVideoCon.vue?vue&type=script&lang=js&"
export * from "./VVideoCon.vue?vue&type=script&lang=js&"
import style0 from "./VVideoCon.vue?vue&type=style&index=0&id=2da4aa94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da4aa94",
  null
  
)

export default component.exports